import { Link, useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import { MdPrivacyTip } from 'react-icons/md';
import './Login.css';

function Login() {
  const navigate = useNavigate();
  const { loginWithGoogle } = useAuth();

  const handleGoogleSuccess = async (credentialResponse) => {
    const result = await loginWithGoogle(credentialResponse.credential);
    if (result.success) {
      navigate('/dashboard');
    } else {
      console.error('Login failed:', result.error);
      alert('Login failed: ' + result.error);
    }
  };

  const handleGoogleError = () => {
    console.error('Google Sign-In failed');
    alert('Google Sign-In failed. Please try again.');
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img src="/icon.png" alt="$Ditto" className="login-logo" />
        <h1 className="login-title">$Ditto</h1>

        <div className="login-signin">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleError}
            useOneTap
            theme="outline"
            size="large"
            text="signin_with"
            shape="rectangular"
          />
        </div>

        <Link to="/privacy-policy" className="login-privacy-link">
          <MdPrivacyTip />
          Privacy Policy
        </Link>
      </div>
    </div>
  );
}

export default Login;
